$(function(){

	if ( ! window.ga)
		return;

	var jplayer = $('#jp-instance');
	var playerHolder = $('#jp-container');

	var gaName = 't0';
	var gaSend = gaName+'.send';
	var gaEventCategory = 'Audio Player';
	
	var yaAccount = '153605';

	function ga_event(params){

		var options = {
			hitType: 'event',
			eventCategory: params.category || gaEventCategory,
			eventAction: params.action
		};

		if (params.label)
		{
			options.eventLabel = params.label;
		}

		//console.log('GA', gaSend);
		//console.log('GA', options);

		ga(gaSend, options);
	}
	
	// Отправка события о достижении цели в Яндекс.Метрику
	function ya_event(target, params)
	{
		console.log('YA', target, params);
		
		try {
			if (window["yaCounter"+yaAccount])
			{
				window["yaCounter"+yaAccount].reachGoal(target, params);
			}
			else
			{
				window["yandex_metrika_callbacks"].push(function(){
					console.log('YA_callback', target);
					window["yaCounter"+yaAccount].reachGoal(target, params);
					target = params = null;
				});
			}
		} catch (e) {
			console.log(e);
		}
	}

	//Запуск файла выпуска
	jplayer.on($.jPlayer.event.play, function(e){

		//При запуске файла выпуска со станицы выпуска
		//или из анонса, сначала проигрывается короткий файл без звука
		//который не нужно учитывать в статистике
		if(e.jPlayer.status.src.indexOf('silence01s.mp3') === -1) {
			//console.log('Запуск файла выпуска');

			var label = $('.js-marquee a').eq(0).text();

			ga_event({
				action: 'Play Start',
				label: label
			});
			ya_event('Residance_Play_Start');

		}
	});

	// Запуск выпуска через кнопку Play
	$('#jp-play', playerHolder).on('click', function(){
		//console.log('Клик плей в сквозном плеере');

		ga_event({
			action: 'Click Play Player'
		});
		ya_event('Residance_Click_Play_Player');
	});

	// Переключение на предыдущий выпуск
	$('#jp-prev', playerHolder).on('click', function(){
		//console.log('Клик по иконке "<" в плеере');

		ga_event({
			action: 'Click Prew Player'
		});
	});

	// Переключение на следующий выпуск
	$('#jp-next', playerHolder).on('click', function(){
		//console.log('Клик по иконке ">" в плеере');

		ga_event({
			action: 'Click Next Player'
		});
	});

	// Включение проигрывания выпусков по кругу
	$('#jp-repeat', playerHolder).on('click', function(){
		//console.log('Клик по иконке "играть по кругу" в плеере');

		ga_event({
			action: 'Click Loop Player'
		});
	});

	//Перемотка выпуска
	jplayer.on($.jPlayer.event.seeking, function(){
		//console.log('Взаимодействие с перемоткой выпуска в плеере');

		ga_event({
			action: 'Rewind Player'
		});
	});

	// Расхлопывание треклиста в сквозном плеере
	$('#jp-tracklist', playerHolder).on('click', function(){
		if( ! $(this).hasClass('active')) {
			//console.log('Расхлопывание треклиста в сквозном плеере');
			ga_event({
				action: 'Open Tracklist Player'
			});
			ya_event('Residance_Open_Tracklist_Player');
		}
	});

	// Клик по названию аудио в плеере
	$('.artist-holder', playerHolder).on('click', function(e){
		//console.log('Клик по названию аудио в плеере');

		ga_event({
			action: 'Click Name Player'
		});
	});

	// Запуск выпуска через кнопку Play на странице выпуска
	s.dom.$main.on('click', '.songs-list .play:not(.pause)',function(e){
		//console.log('Клик плей на странице выпуска');

		ga_event({
			category: 'Pages Episodes',
			action: 'Click Play Page'
		});
		ya_event('Residance_Click_Play_Page');
	});

	// Запуск выпуска через кнопку Play в анонсе выпуска
	s.dom.$main.on('click', '.release-anons .play:not(.pause)',function(e){
		//console.log('Клик плей в списке анонсов');

		ga_event({
			category: 'Pages Episodes',
			action: 'Click Play Preview'
		});
		ya_event('Residance_Click_Play_Preview');
	});

	// Расхлопывание треклиста на странице выпуска
	s.dom.$main.on('click', '.track-list-block i',function(e){
		//console.log('Расхлопывание треклиста на странице выпуска');

		ga_event({
			category: 'Pages Episodes',
			action: 'Open Tracklist Page'
		});
		ya_event('Residance_Open_Tracklist_Page');
	});

	// Расхопывание описания выпуска
	s.dom.$main.on('click', '.container-release .expanded-block i',function(e){
		//console.log('Расхопывание описания выпуска');

		ga_event({
			category: 'Pages Episodes',
			action: 'Open Description Episode'
		});
	});

	// Переход в соцсеть арстиста по иконке на изображении страницы выпуска
	s.dom.$main.on('click', '.container-release .share-visual a',function(e){
		//console.log('Переход в соцсеть арстиста по иконке на изображении страницы выпуска');

		ga_event({
			category: 'Pages Episodes',
			action: 'Click Social Episode'
		});
	});

	jplayer = playerHolder = null;
});